import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "spaceToListJoin",
    standalone: false
})
export class SpaceToListJoinPipe implements PipeTransform {
	transform(joinnedList: string, separator = ","): any {
		let splitList = `${joinnedList}`.split(separator);
		return splitList.join(", ");
	}
}
